import { render, staticRenderFns } from "./CurriculumComment.vue?vue&type=template&id=35d5f204&"
import script from "./CurriculumComment.vue?vue&type=script&lang=js&"
export * from "./CurriculumComment.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumComment.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports